"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { TEAMS } from "@/components/team_selector/teams";
import { feedKind } from "@/lib/feed-filters";
import styles from "./feed_tabs.module.css";

const genres = [
	{ key: "all", label: "すべて", href: "/?feed=all" },
	{ key: "baseball", label: "野球", href: "/" },
	{ key: "talk", label: "なんJ・雑談", href: "/?feed=talk" },
];

/** ジャンル・12球団の絞り込みを表示する。activeは検証済みのキー。保存の副作用なし。 */
function TabLinks({ active = "" }: { active?: string }) {
	return (
		<div className={styles.navigation}>
			<nav className={styles.tabs} aria-label="記事の絞り込み" data-testid="feed-tabs">
				<div className={styles.genres}>
					{genres.map((genre) => (
						<Link
							key={genre.key}
							href={genre.href}
							scroll={false}
							aria-current={active === genre.key ? "page" : undefined}
						>
							{genre.label}
						</Link>
					))}
				</div>
				<div className={styles.teams}>
					{TEAMS.map((team) => (
						<Link
							key={team.key}
							href={"/team/" + team.key}
							scroll={false}
							className={styles.team}
							aria-label={team.shortName}
							title={team.shortName}
							aria-current={active === team.key ? "page" : undefined}
						>
							<Image
								src={team.icon}
								width={29}
								height={29}
								alt=""
								loading="eager"
								unoptimized
							/>
						</Link>
					))}
				</div>
			</nav>
		</div>
	);
}

/** 公開URLから選択中の球団・ジャンルを判定する。遷移時も注目欄を再生成せずリンクの選択だけ更新する。 */
function CurrentTabs() {
	const pathname = usePathname();
	const query = useSearchParams();
	const team = pathname.startsWith("/team/") ? pathname.split("/")[2] : query.get("team");
	const selectedTeam = TEAMS.find((item) => item.key === team);
	const active = selectedTeam?.key ?? (pathname === "/" ? feedKind(query.get("feed") ?? "") : "");
	return <TabLinks active={active} />;
}

/** URL解決中も同じ高さのナビを描画する。引数・副作用・例外なし。 */
export default function FeedTabs() {
	return (
		<Suspense fallback={<TabLinks />}>
			<CurrentTabs />
		</Suspense>
	);
}
